export default __webpack_public_path__ + "static/media/ArtificialGrass.9427153e.png";